'use strict';

var _require = require('./baseProperties'),
    baseProperties = _require.baseProperties;

module.exports.KooperationSchema = {
  title: 'Kooperation',
  type: 'object',
  properties: Object.assign({}, baseProperties, {
    beginn: {
      type: 'string',
      format: 'date-time'
    },
    ende: {
      type: 'string',
      format: 'date-time'
    }
  })
};


//////////////////
// WEBPACK FOOTER
// ./~/fobclient/lib/schema/kooperation.js
// module id = XdEz
// module chunks = 0